<ng-container *ngIf="sessionFiles$ | async as sessionFiles; else loadingState">
  <ng-container *ngIf="sessionFiles.length > 0; else emptyState">
    <!-- Filters -->
    <form [formGroup]="filterFields" class="file-filters form-full-width">
      <span class="filter-field" style="flex: 3">
        <mat-form-field appearance="outline">
          <mat-label>BIDS File Name</mat-label>
          <mat-icon matPrefix class="xs">filter_alt</mat-icon>
          <input type="text" matInput formControlName="fileName" autocomplete="off">
        </mat-form-field>
      </span>
      <span class="filter-field" style="flex: 2">
        <mat-form-field appearance="outline" aria-label="File Type">
          <mat-select formControlName="fileType" class="muted">
            <mat-option value="">All Types</mat-option>
            <mat-option *ngFor="let fileType of fileTypes" [value]="fileType">{{ fileType }}</mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </form>

    <!-- Data -->
    <ng-container *ngFor="let bucket of bidsBuckets$ | async">
      <div *ngIf="bucket.files.length > 0">
        <div class="bucket-name">{{ bucket.label }}</div>
        <div *ngFor="let file of bucket.files" class="bids-file" [ngClass]="{disabled: isQuarantined(file)}">
          <span class="file-origin">
            <ng-container *ngIf="getFileOrigin(file) as originInfo">
              <mat-icon *ngIf="originInfo.matIcon" [matTooltip]="originInfo.popoverText" class="xs">{{ originInfo.matIcon }}</mat-icon>
            </ng-container>
          </span>
          <span class="file-name-version" style="flex: 3">
            <fw-ellipsis [text]="file.info?.BIDS?.Filename || file.name"></fw-ellipsis>
            <file-version-badge *ngIf="file.version > 1" [file]="file" class="version-badge"></file-version-badge>
          </span>
          <div class="file-type-actions" style="flex: 2">
            <span class="file-type">{{ file.type }}</span>
            <file-actions *ngIf="!isQuarantined(file)" [file]="file" [container]="fileParents.get(file)"
              [hoverFeatures]="$any(['view', 'info', 'download'])"
              [kabobFeatures]="$any(['info', 'download', 'delete', 'version-history', 'copy-filename', 'copy-modality', 'view'])"
              [viewParams]="fileViewParameters"
              (afterChange)="loadFiles()"
              (afterDelete)="loadFiles()">
              <button action="view" mat-icon-button matTooltip="View" class="xs">
                <mat-icon class="xs">panorama_outline</mat-icon>
              </button>
              <button action="info" mat-icon-button matTooltip="Information" class="xs">
                <mat-icon class="xs">info</mat-icon>
              </button>
              <button action="download" mat-icon-button matTooltip="Download" class="xs">
                <mat-icon class="xs">cloud_download</mat-icon>
              </button>
              <button mat-icon-button class="xs">
                <mat-icon class="xs">more_vert</mat-icon>
              </button>
            </file-actions>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #loadingState>
  <div *ngIf="!error; else errorState" class="loading-state">
    <mat-progress-bar mode="buffer"></mat-progress-bar>
  </div>
</ng-template>

<ng-template #emptyState>
  <div class="info-message">
    <div class="fab">
      <mat-icon>list</mat-icon>
    </div>
    <p>There are no files in this session yet.</p>
  </div>
</ng-template>

<ng-template #errorState>
  <div class="info-message">
    <div class="fab">
      <mat-icon>error_outline</mat-icon>
    </div>
    <p>Session files could not be retrieved.</p>
    <button mat-flat-button (click)="loadFiles()" color="primary">Reload Data</button>
  </div>
</ng-template>
